export const NAVBAR_OVERFLOW_ITEMS = [
    { id: 'trigger-manual', icon: 'fa-book', title: 'Action.UserManual' },
    { id: 'trigger-map-capture', icon: 'fa-camera', title: 'Action.ScreenCapture' },
    { id: 'trigger-compare', icon: 'fa-columns', title: 'Action.ToggleCompareMaps' },
    { id: 'trigger-dashboard', icon: 'fa-line-chart', title: 'Action.ReportsCenter' },
];

export const isNavbarItemEnabled = ({ id }) => {
    const el = document.getElementById(id);
    return !!el && el.style.display !== 'none';
};



// WEBPACK FOOTER //
// ./src/modules/shared/components/navbar-overflow/navbar-overflow.helper.js